import { useState } from "react";
import { FilterRowDesktop } from "./FilterRowDesktop/FilterRowDesktop";
import { AppliedFilterRow } from "./AppliedFilterRow/AppliedFilterRow";
import { FilterModal } from "./FilterModal/FilterModal";
import trackerHelper from "@coworker/app/src/helpers/tracker";
import { Filter, FilterValue } from "../types/filter";
import { TrackingProps } from "../types/component";

interface FilterPanelDesktopProps {
  useFiltersFactory: (
    filterValues: FilterValue[],
    setFilterValues: (values: FilterValue[]) => void
  ) => Filter[];
  filterValues: FilterValue[];
  setFilterValues: (filterValues: FilterValue[]) => void;
  feature: string;
}

// Main component to view filters.
export const FilterPanelDesktop = ({
  useFiltersFactory,
  filterValues,
  setFilterValues,
  feature,
}: FilterPanelDesktopProps) => {
  const [filterModalIsOpen, setFilterModalIsOpen] = useState(false);
  const [scrollTo, setScrollTo] = useState("");
  const filters = useFiltersFactory(filterValues, setFilterValues);
  const [newFilterValue, setNewFilterValue] = useState<FilterValue | null>(
    null
  );
  const tracking: TrackingProps = { feature, mode: "desktop" };

  const onTriggerFilter = (filterId: string, filterValue?: FilterValue) => {
    setNewFilterValue(filterValue || null);
    setFilterModalIsOpen(true);
    setScrollTo(filterId);
  };

  const setFilterValuesWithTracking = (values: FilterValue[]) => {
    setFilterValues(values);
    trackerHelper.filter.trackFilterValues(tracking.feature, values);
  };

  return (
    <>
      <FilterRowDesktop
        filters={filters}
        filterValues={filterValues}
        setFilterValues={setFilterValuesWithTracking}
        onTriggerFilter={onTriggerFilter}
        tracking={tracking}
      />
      <AppliedFilterRow
        filters={filters}
        filterValues={filterValues}
        setFilterValues={setFilterValuesWithTracking}
        tracking={tracking}
      />
      <FilterModal
        visible={filterModalIsOpen}
        scrollTo={scrollTo}
        useFiltersFactory={useFiltersFactory}
        filterValues={filterValues}
        setFilterValues={setFilterValuesWithTracking}
        onClose={() => setFilterModalIsOpen(false)}
        newFilterValue={newFilterValue}
        tracking={tracking}
      />
    </>
  );
};
